// flow weak

import React, {
    Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  // import AnimatedView           from '../../../../components';
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
  import styles                 from './style'
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog'
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import {
    AnimatedView,
    StatsTable,ScoreCard,StatsGraph
  }                         from '../../../components';
  import {Link} from 'react-router-dom';
  import ReactTooltip from 'react-tooltip';

  import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import { isNull } from 'util';
import device     from "current-device";
import { Spinner } from 'react-activity';
import 'react-activity/dist/react-activity.css';


const is_mobile = device.mobile;  
const unbook_button_style={width:'120%',fontSize:'80%',height:'30px',color:'white',backgroundColor:'grey',};

  class PartnerCourtBooking extends Component {
    static propTypes = {
      earningGraphLabels:   PropTypes.array,
      revenueChart:  PropTypes.shape({
        headers: PropTypes.array,


        data: PropTypes.array
      }),
      earningGraphDatasets: PropTypes.array,
      teamMatesIsFetching:  PropTypes.bool,
      teamMates:            PropTypes.arrayOf(
        PropTypes.shape({
          picture:      PropTypes.string,
          firstname:    PropTypes.string,
          lastname:     PropTypes.string,
          profile:      PropTypes.string,
          profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
        })
      ),
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        court_list: [],
        selected_court_ids:[],
        venue_list: [],
        game_list: [],
        selected_venue: '',
        selected_venue_name:'',
        selected_game: '',
        selected_game_name:'',
        slot_list:{},
        booking_details: {},
        selected_date: moment(),
        cb_logs:[],
        show_log_dialog:false,
        cust_details:{
          mobile_no: '',
          name: '',
          venue: '',
          date: moment(),
          start_date: moment(),
          end_date: moment().add(1, 'month'),
          start_time: '',
          end_time: '',
          amount: 0,
          customer_id: '',
          package:'',
          display_name:'',
          coupon:'',
          source:'WALK IN'
        },
        sub_details: {},
        booking_data: {},
        cart_items: [],
        discount_amount: 0,
        collected_amount: 0,
        advance_amount: 0,
        slot_price:0,
        search:false,
        amount:0,
        equipment_mode:'',
        customer_search_list: [],
        dialog_open_cust:true,
        isHovering:false,
        rental_revenue_per_day_graph_tabs: [ 
          {name: 'Data', tablink: '1', isActive: true}, 
          {name: 'Daily Court Usage', tablink: '2', isActive: false},
          
      ],
      rental_revenue_per_day: [ 
          {name: 'Data', tablink: '3', isActive: true}, 
          {name: 'Daily Rental', tablink: '4', isActive: false},
          
      ], 
      payment_modes: [],
      payments: [
        {amount:0,mode:''}
      ],
      payment_mode:'',
      selected_bookings: [],
      cart: {},
      checkout: false,
      total_amount: 0,
      failed_slots: [],
      failed_count: 0,
      show_dialog: false,
      update_dialog: false,
      court_booking_id:'',
      booking_summary:false,
      value_set: false
      };
      this.handleVenueChange = this.handleVenueChange.bind(this);
      this.handleShowSlots = this.handleShowSlots.bind(this);
      this.handleSlots = this.handleSlots.bind(this);
      this.searchCustomer = this.searchCustomer.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
      this.handleDate = this.handleDate.bind(this);
      this.handleGameChange = this.handleGameChange.bind(this);
      this.checkLog = this.checkLog.bind(this);
      this.handleMode = this.handleMode.bind(this);
      this.tConvert = this.tConvert.bind(this);
      }
  
    componentDidMount() {
      const {
        actions: {
          fetchStatsTableDataIfNeeded,
        }
      } = this.props;
      this.getVenueList();
      this.paymentModes();

    $('.collection-trend').find("a").trigger("click");
    $('.daily-trend').find("a").trigger("click");
    }
    paymentModes(){
      const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({payment_modes:data.payment_modes});
           // alert("fix");
       }).catch(error => error);
    }
  
    getVenueList(){
      const url = `${getLocationOrigin()}/court/get_rental_venue_for_buddy/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({ venue_list: data.results,selected_venue_name:data.results[0].name, selected_venue: data.results[0].id, game_list:data.results[0].games,selected_game: data.results[0].games[0].game_id,selected_game_name:data.results[0].games[0].game_name},()=>{this.getSlots()}))
         .catch(error => error);
    }

    handleVenueChange(event){
      console.log('eveny')
      console.log(event.target.value)

      this.state.game_list = this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      if(event.target.value == 'b97a56d4-5742-4a6a-9d03-f4a88c992d21'){
        this.setState({selected_venue:event.target.value,selected_game:this.state.game_list[1].game_id})
      }
      else{
        this.setState({selected_venue:event.target.value,selected_game:this.state.game_list[0].game_id})
      }
      // console.log(this.state.venue_list)
      // console.log(this.state.game_list)
      

      // this.getSlots(event.target.value)
    }

    handleGameChange(event){
      this.setState({selected_game:event.target.value})
      // console.log(this.state.selected_game)
    }

    handleSlots(obj){
      // console.log('obj')
      // console.log(obj)
      if(obj.is_booked_as_other_part === false && obj.is_booking_in_progress == false){
        if (this.state.selected_court_ids.indexOf(obj.id)>-1){
          this.state.selected_court_ids = this.state.selected_court_ids.filter(id => id != obj.id )
        } 
        else{
          this.state.selected_court_ids.push(obj.id)
          this.setState({loading:false,booking_summary:true})
        }
        
        if(obj.is_blocked === true){
          this.setState({is_blocked:true })
        }


        const url = `${getLocationOrigin()}/court_booking/get_details_for_court_booking/?court_booking_id=${obj.id}`;
        const options = {...defaultOptions};
    
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => this.setState({ 
            booking_details: data,
            slot_total_price:data.price,
            discount_amount:0,
            loading:false,
            cb_logs:data.court_booking_log
          },()=>{this.handleSelectedSlots(data)})
          )
          .catch(error => error);

        console.log('sss')
       
      }
    }

    handleSelectedSlots(slot){
      var temp_slot = this.state.selected_bookings
      // console.log('all_slots',temp_slot)

      if(slot.is_booked === false){
        this.setState({loading:true})
        var check = temp_slot.find((value)=>{return(value.id == slot.id)})
        // console.log('check')
        // console.log(check)
        if(check){
          temp_slot.splice(temp_slot.indexOf(check),1)
        }
        else{
          temp_slot.push(slot)
        }
        var slots = [slot.id]
        var courts = [slot.court.id]
        let cart_item={
              "date":slot.date,
              "court_booking_ids" : slots,
              "court_ids": courts,
              "start_time" : moment(slot.start_time,"HH:mm:ss").format('hh:mm A'),
              "end_time" : moment(slot.end_time,"HH:mm:ss").format('hh:mm A'),
             }
        // console.log('cart_item',cart_item)
        var items_copy = [...this.state.cart_items]
        var IndexofOldOne = items_copy.findIndex(item=>item["start_time"] == cart_item.start_time && item["date"] == cart_item.date)

        if(IndexofOldOne > -1){
            if(!items_copy[IndexofOldOne].court_booking_ids.includes(slot.id)){
              // console.log('found',items_copy[IndexofOldOne])
              items_copy[IndexofOldOne].court_booking_ids.push(slot.id)
              items_copy[IndexofOldOne].court_ids.push(slot.court.id)
            }
            // items_copy[IndexofOldOne] = cart_item            
        }else{
            items_copy.push(cart_item)
        }
        // console.log('all_slots',temp_slot)
        // console.log('cart_items',items_copy)

        this.setState({selected_bookings:temp_slot,cart_items:items_copy,loading:false},()=>{this.totalAmount()})
      }
      // console.log('selected_bookings',this.state.selected_bookings)
    }

    removeFromCart(slot){
      console.log('removeFromCart')
      this.setState({loading:true})
      var temp_slot = this.state.selected_bookings
      var items_copy = [...this.state.cart_items]
      var slot_start = moment(slot.start_time,"HH:mm:ss").format('hh:mm A')
      items_copy.forEach(item=>{
        if(item.start_time == slot_start){
          var check_slot = item.court_booking_ids.findIndex(data=> data == slot.id)
          item.court_booking_ids.splice(check_slot,1)
          var check_court = item.court_ids.findIndex(data=> data == slot.court.id)
          item.court_ids.splice(check_court,1)
        }
        if(item.court_booking_ids.length == 0 && item.court_ids.length == 0){
          var empty_check = items_copy.findIndex(data=> data.start_time == slot_start)
          items_copy.splice(empty_check,1)
        }
     })

      var check = temp_slot.find((value)=>{return(value.id == slot.id)})
      temp_slot.splice(temp_slot.indexOf(check),1)
      if(temp_slot.length == 0){
        this.setState({checkout:false})
      }
      this.setState({selected_bookings: temp_slot,cart_items:items_copy,loading:false},()=>{this.totalAmount()})
      // console.log(temp_slot)
    }

    totalAmount(){
      var temp_slot = this.state.selected_bookings
      var amount = 0
      temp_slot.map((slot)=>
        amount += slot.price
        )
      // console.log('amount',amount)
      this.setState({total_amount:amount,slot_price:amount})
    }

    handleCheckout(){
      if(!this.state.cust_details.customer_id){
        alert('Please select customer first')
      }
      else{
        this.addToCart(this.props,this.state.cart_items)
      }
    }

    addToCart(props,cart_items){
      const url = `${getLocationOrigin()}/cart/add_to_cart/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'customer_id': this.state.cust_details.customer_id,
                          'court_booking_new': cart_items,
                          'source': 'portal'
                        });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({cart: data,checkout:true,advance_amount:data.amount}))
        .catch(error => {
          console.log(error);
          alert(error.message);
        })
    }


    handleClose = () => {
      this.setState({dialog_open_cust:false});
    };

    handleFailedClose = () => {
      this.setState({open_dialog:false});
      window.location.reload();
    }

    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }

    handleUpdateClose = () => {
      this.setState({update_dialog:false})
    }

    handleCustomerSubmit(){
      console.log('post');
      if(!this.state.cust_details.mobile_no){
        alert('Please enter mobile number.')
      }
      else{
        
        const url = `${getLocationOrigin()}/eagleeye/add_new_customer/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'customer_name': this.state.cust_details.name,
                            'customer_mobile': this.state.cust_details.mobile_no,
                          });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .catch(error => {
            console.log(error);
            alert(error.message);
          })
          .then(data => {
            if(data.success){
              var cust = Object.assign([], this.state.cust_details);
              cust.push({'id': data.customer.id, 'name': data.customer.name, 'mobile_no':data.customer.mobile_no});
              this.setState({customer_search_list: cust});
              alert(data.message);
              this.handleClose();
            } else {
              alert(data.message);
            }
           });
      }
    }

    getSlots(){
      console.log("im here");
      this.setState({loading:true,booking_details:{}})
      var venue_id = this.state.selected_venue
      var game_id = this.state.selected_game
      var venue_name = this.state.venue_list.filter(venue => venue.id == venue_id)[0].name
      var game_name = this.state.game_list.filter(game => game.game_id == game_id)[0].game_name
      this.setState({selected_venue_name:venue_name,selected_game_name:game_name})
      var selected_date = moment(this.state.selected_date).format("YYYY-MM-DD")
      var game = this.state.selected_game
      const url = `${getLocationOrigin()}/court_booking/get_court_booking_state/?venue_id=${venue_id}&date=${selected_date}&game=${game}`;
      const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({ slot_list: data.slots,court_list:data.court_names,loading:false,selected_bookings:[],cart_items:[]}))
         .catch(error => error);
      
    }

    handleShowSlots(){
      this.setState({selected_court_ids:[],checkout:false})
      this.getSlots()
    }

    handleChange(event) {
      const name = event.target.name;
      var new_selected_one =  Object.assign({}, this.state.cust_details);
      new_selected_one[name] = event.target.value
      // console.log(new_selected_one)
      this.setState({cust_details: new_selected_one});
      // console.log(this.state)
    }

    handleMode(event) {
      const name = event.target.name;
      var value = event.target.value
      this.setState({payment_mode:value})
    }

    handleDate(date){
      this.setState({selected_date: date});
    }

    cancelBooking(court_booking_id){
      var msg = `Are you sure?`;
      var result = confirm(msg);
      if(result){
        const url = `${getLocationOrigin()}/court/cancel_court_booking_from_portal/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({'court_booking_id': court_booking_id,
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){                      
              alert(response.message);
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }
    }

    updateSubscription(){
      const payments = [...this.state.payments]
      let payment_total = 0
      let is_pay_later = false
      let is_blank = false
      for (let i = 0; i < payments.length; i++) {
        payment_total += Number(payments[i].amount)
        if(payments[i].mode === 'paylater'){
          is_pay_later = true
        }
        if(payments[i].mode === ''){
          is_blank = true
        }
      }

      if(this.state.amount != 0 && is_pay_later){
        alert("Please remove paylater")
      }
      else if(is_blank){
        alert("Please select payment mode")
      }
      else if(this.state.amount != payment_total){
        alert("Please Ensure amount is equal to multiple payments total.")
      }
      else if((Number(this.state.amount) + Number(this.state.discount_amount)) < Number(this.state.booking_details.booking_details.remaining_amount)){
        alert('Total of amount and discount amount should be equal to the remaining amount');
      }
      else{
        const url = `${getLocationOrigin()}/court_booking/update_rental_subscription/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({'court_booking_id': this.state.court_booking_id,
                                          'customer': this.state.cust_details.customer_id,
                                          'amount':this.state.amount,
                                          'discount_amount': this.state.discount_amount,
                                          'payments': payments
                                          // 'mode': this.state.payment_mode
                                          });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then((response) => {  
              this.setState({amount:'',cust_details:{},payments:[{amount:0,mode:''}],amount:0,discount_amount:0,update_dialog:false,value_set:false})                    
              alert(response.message);
              this.getSlots();
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
        }
     }

    cancelBookingPress(court_booking_id){
      this.cancelBooking(court_booking_id)
      // this.getSlots();
    }

    updateSubscriptionPress(court_booking_id){
      this.setState({court_booking_id:court_booking_id,update_dialog:true})
      // if(this.state.amount > 0){
      //   this.updateSubscription(court_booking_id)
      // }
      // else{
      //   alert("Enter Amount")
      // }
    }

    downloadInvoicePress(details){
      this.downloadInvoice(details.booking_details.subscription_id)
    }

    downloadInvoice(subscription_id){
      const url = `${getLocationOrigin()}/invoice/download/?subscription_id=${subscription_id}`;
      window.open(url);
    }
    

    getSearchList(mobile_no) {
      const url = `${getLocationOrigin()}/eagleeye/search/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                           'search': mobile_no
                         });
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({customer_search_list: data.results, search: true}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
    }

    removeCartItem(customer_id, item_id){
      const url = `${getLocationOrigin()}/cart/remove_from_cart/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
          'customer_id': customer_id,
          'item_id': item_id,
      });
       // console.log(this.state.checkout)
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {this.setState({cart: data,checkout:false,cart_items:[],cust_details:{},selected_bookings:[],value_set:false})
          this.state.selected_bookings.pop(data)
          if(this.state.selected_bookings.length<1){
            this.setState({selected_court_ids:[]})
            // window.location.reload();
          }
          })
         
         .catch(error => {
           console.log(error);
           console.log('removeCartItem..')
           console.log(this.state.checkout)
           alert(error.message);
         });
    }

  addBooking(data, cart, props,payments) {
    let found = ["items"].every(r=> Object.keys(cart).includes(r))
    // if(!data.payment_mode){data.payment_mode = Object.keys(this.state.payment_modes)[0]}
    if (found == false){
        alert("Cart is empty, please add atleast one package");
    } else{
        if (cart.items.length < 1){
          alert("Cart is empty, please add atleast one package");
        }
        else if(!data.source){
          alert('Source is missing, please add source');
        }
        else if(this.state.advance_amount > cart.amount){
          alert('Advance amount should be less than or equal to the total amount');
        }
        else if((Number(this.state.advance_amount) + Number(this.state.discount_amount)) > cart.amount){
          alert('Total of advance and discount amount should be less than or equal to the total amount');
        }
        else if (data.customer_id != ""){
            var msg = `Are you sure?`;
            var result = confirm(msg);
            if (result == true){
                const url = `${getLocationOrigin()}/eagleeye/add_rental/`;
                const options = {...defaultOptions};
                options['method'] = 'post';
                options['headers'] = {'content-type': 'application/json'}
                options['body'] = JSON.stringify({
                    'customer_id': data.customer_id,
                    'payments': payments,
                    'source': data.source,
                    'advance_amount': this.state.advance_amount,
                    'discount_amount': this.state.discount_amount
                });
                console.log('Going to fetch');
                return fetch(url, options)
                .then(checkStatus)
                .then(parseJSON)
                .then((response) => {
                    console.log(response) 
                    alert(response.message)                   // first then()
                    this.setState({checkout:false,booking_summary:false,cust_details:{},payments:[{amount:0,mode:''}],advance_amount:0,discount_amount:0,value_set:false})
                    this.getSlots();
                    // location.reload();
                    // props.history.goBack();
                })
                .catch(error => {
                    console.log(error);
                    alert(error.message);
                });
            }
        }
        else {
            alert("Customer details missing");
        }
    }
  }

    onAddBookingPress(){
      const payments = [...this.state.payments]
      let payment_total = 0
      let is_pay_later = false
      let is_blank = false
      for (let i = 0; i < payments.length; i++) {
        payment_total += Number(payments[i].amount)
        if(payments[i].mode === 'paylater'){
          is_pay_later = true
        }
        if(payments[i].mode === ''){
          is_blank = true
        }
      }
      // console.log('payment_total',payment_total)
      // console.log(this.state.advance_amount)
      // console.log(this.state.slot_price)
      console.log('total advance_amount',Number(this.state.advance_amount) + Number(this.state.discount_amount))
      // if(this.state.advance_amount != this.state.slot_price && is_pay_later == false){
      //   alert("Please Ensure that payment total is equal to total advance amount")
      // }
      // else 
      if(this.state.advance_amount != 0 && is_pay_later){
        alert("Please remove paylater")
      }
      if(this.state.advance_amount == 0 && !is_pay_later){
        alert("Please select paylater when there is no advance amount")
      }
      else if(is_blank){
        alert("Please select payment mode")
      }
      else if(!this.state.cust_details.customer_id){
        alert("Please Enter Details")
      }
      else if(this.state.advance_amount != payment_total){
        alert("Please Ensure advance amount is equal to multiple payments total.")
      }
      else{
        // console.log('1111...')
        // console.log(this.state.payments)
        this.addBooking(this.state.cust_details,this.state.cart,this.props,this.state.payments)
      }
    }

    handleDiscountApply = () => {
      var amount = this.state.total_amount
      if(this.state.discount_amount > amount){
        var slot_price = 0
        this.setState({slot_price:slot_price})
      }
      else{
        var slot_price = amount - this.state.discount_amount
        this.setState({slot_price:slot_price}) 
      }
    }

    applyCoupon(coupon_code){
      var customer_id = this.state.cust_details.customer_id;
      if (customer_id == ""){
          alert("Please select a customer first");
      }
      if (this.state.cart == null){
          alert("Cart cannot be empty");
      }
      else if (this.state.cart.items.length < 1){
          alert("Cart cannot be empty");
      }
      else {
          const url = `${getLocationOrigin()}/cart/apply_coupon/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
              'customer_id': customer_id,
              'coupon_code': coupon_code,
          });
          return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
              var temp = {};
              if (data.coupon.success != true){
                  temp['cust_details'] =  Object.assign({}, this.state.cust_details);
                  temp['cust_details']['coupon'] = "";
                  alert(data.coupon.message);
              }
              temp['cart'] = data;
              this.setState(temp);
          })
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
      }
    }

    removeCoupon(coupon_code){
      var customer_id = this.state.cust_details.customer_id;
      if (customer_id == ""){
          alert("Please select a customer first");
      }
      else if (this.state.cart == null){
          alert("Cart cannot be empty");
      }
      else if (this.state.cart.items.length > 1){
          alert("Cart cannot be empty");
      }
      else {
          const url = `${getLocationOrigin()}/cart/remove_coupon/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
              'customer_id': customer_id,
              'coupon_code': coupon_code,
          });
          return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
              var temp = {};
              temp['cust_details'] =  Object.assign({}, this.state.cust_details);
              temp['cust_details']['coupon'] = "";
              temp['cart'] = data;
              this.setState(temp);
          })
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
      }
    }

    searchCustomer() {
      {this.state.cust_details.display_name?this.getSearchList(this.state.cust_details.display_name):
        alert('Search cannot be blank')}
    }

    setSearch(name, customer_id, mobile_no){
      var new_selected_one =  Object.assign({}, this.state.cust_details);
      new_selected_one['customer_id'] = customer_id
      new_selected_one['mobile_no'] = mobile_no
      new_selected_one['name'] = name
      new_selected_one['display_name'] = `${name}:${mobile_no}`;
      this.setState({cust_details: new_selected_one, search: false, value_set:true});
    }

    updateRenatal(id){
      console.log('updateREnat')
      const url = `./crud/updateCourtBooking/${id}`;
      <Link to = {url} />
    }

    checkLog(){
      this.setState({show_log_dialog:true})
    }

    tConvert (time) {
      time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) { // If time format correct
        time = time.slice (1);  // Remove full string match value
        // console.log(time)
        time = time.slice(0,-1)
        // console.log(time)
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join (''); // return adjusted time or original string
    }

    addPaymentClick(){
      this.setState(prevState => ({
        payments: [...prevState.payments,{mode:'',amount:0}]
      }));
    }

    removePaymentClick(i){
      let payments = [...this.state.payments];
      payments.splice(i,1);
      this.setState({payments});
    }

    handlePaymentChange(index,event){
      const {name,value} = event.target;
      let payments = [...this.state.payments];
      payments[index] = {...payments[index],[name]:value};
      this.setState({payments});
    }

    handleDateChangeRaw = (e) => {
      e.preventDefault();
    }

  compareObjects(object1, object2, key) {
      const obj1 = object1[key].toUpperCase()
      const obj2 = object2[key].toUpperCase()

      if (obj1 < obj2) {
        return -1
      }
      if (obj1 > obj2) {
        return 1
      }
      return 0
    }


    createPaymentUI(){
      return this.state.payments.map((payment,index)=>(
        <div key={index}>
          <div style={styles.items} className="col-md-12">
            <div style={styles.item_header} className="col-md-6">
              Amount {index+1}
            </div>
            <div className="col-md-6" >
              <input type="number" style={styles.input} name="amount" 
                value={payment.amount} onChange={this.handlePaymentChange.bind(this,index)}/> 
            </div>
          </div>          
          <div style={{padding: '1%',display:'flex',flexDirection:'row'}} className="col-md-12">
            <div style={styles.item_header} className="col-md-6">
              Payment Mode {index + 1}
            </div>
            <select name="mode" className="col-md-6" style={styles.item_body} value={payment.mode}
               onChange={this.handlePaymentChange.bind(this,index)}>
               <option>--select--</option>
                {
                   Object.keys(this.state.payment_modes).map((key, index) => (
                   <option key={key} value={key}>{`${this.state.payment_modes[key]}`}</option>
                   ))
                 }
            </select>
          </div>
          { this.state.payments.length > 1 &&
            <div  style={{direction:'rtl'}}><i className='fa fa-times fa-2x' onClick={this.removePaymentClick.bind(this, index)} style={{color:'red',cursor:'pointer'}}/></div>
          }
        </div>
        ))
    }
  
    render() {
            console.log('render.....*')
        
      console.log(this.state.game_list)
      this.state.game_list.sort((game1, game2) => {
        return this.compareObjects(game1, game2, 'game_name')
      })

      // console.log(this.state.slot_list)
      var total = this.state.total_amount
      // console.log(this.state.checkout)
      // console.log(this.state.selected_bookings)
      // console.log(this.state.cart)

      const booking_headers = [' ','Court','Date','Time','Price',' ']
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];
      const okaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleFailedClose}
        />,
      ];

      const update_action = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleUpdateClose}
          />,
          <FlatButton
            label="Update"
            primary={true}
            onClick={()=>{this.updateSubscription()}}
          />,
        ];

      const okayaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={()=>{this.setState({show_log_dialog:false})}}
        />,
      ];

      const {
        statsTable, scoreCard,statsGraph
      } = this.props;
  
      const {
        actions: {
          fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
        }
      } = this.props;
    return(
        <div>
        {/*<div className="col-md-12" >
                  <ScoreCard name="score_card_rental" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
                </div>*/}

        <div className='row' style={{textAlign:'center',display:'flex',justifyContent:'flex-end'}}>
          <div style={{marginTop:'2%'}}>
              <Link style={{fontSize:'80%'}} to={`./courtBookingList`} >
                <button style={{marginLeft:'5px'}} className='button1'>Court Bookings </button>
              </Link>
              <Link to={`./equipmentRentalList`} >
                <button style={{marginLeft:'5px'}} className='button1'>Equipment Rentals </button>
              </Link>
              <Link to={`./itemsSoldList`} >
                <button style={{marginLeft:'5px'}} className='button1'>Items Sold </button>
              </Link>
              <Link to={`./crud/foodRental`} >
                <button style={{marginLeft:'5px'}} className='button1'>F &amp; B Rental </button>
              </Link>
              <Link to={`./crud/addRental`} >
                <button style={{marginLeft:'5px'}} className='button1'>Block Courts </button>
              </Link>
              <Link to={`./bulkBookingList`}>
                <button style={{marginLeft:'5px'}} className='button1'>Bulk Bookings </button>
              </Link>
            </div>
        </div>

        
        
        

        <div style={{margin:10}}> 
          <div className="row">    
          <div className="row col-md-12" style={styles.table}>
            
            <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
              
              <div className="col-md-2" style={{padding:'1%'}}> 
                <DatePicker selected={this.state.selected_date} onChangeRaw={this.handleDateChangeRaw} onChange={this.handleDate} readonly/>
              </div>

              <div style={{padding: '1%'}} className="col-md-2">
                <select  name="venue"  style={styles.item_body} style={{backgroundColor:'white',width:'100%'}} value={this.state.value}
                  onChange={this.handleVenueChange}>
                  {
                    this.state.venue_list.map((x, index) => (
                    <option key={x.id} value={x.id}>{x.name}</option>
                    ))
                  }
                </select>
              </div>

              <div style={{padding: '1%'}} className="col-md-2" >
                <select name="game"  style={styles.item_body} style={{backgroundColor:'white',width:'100%'}} value={this.state.selected_game}
                  onChange={this.handleGameChange}>
                  {
                    this.state.game_list.map((x, index) => (
                    <option key={x.game_id} value={x.game_id}>{x.game_name}</option>
                    ))
                  }
                </select>
              </div>

              
              <button onClick={this.handleShowSlots} className='col-md-2 button1'>Show Slots </button>
            </div>
          <div style={is_mobile()? {fontSize:'18px',fontWeight:'bold',textAlign:'center'}:{fontSize:'18px',fontWeight:'bold',textAlign:'center'}}>
          
          {this.state.selected_venue_name} - {this.state.selected_game_name}
          
          </div>

          {this.state.loading === true ?
                <div style={{height:500}}>
                  <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
                  </div>
            :
          <div>
          {Object.keys(this.state.booking_details).length > 0 && this.state.booking_details.is_booked == true &&
            <div className="row col-md-10" style={styles.cart}>
              <div style={styles.booking}>Booking Details</div>
                <div className="row col-md-12" style={styles.cart_rows}>
                  <div className="row col-md-6" style={styles.cart_contents}>Name : {this.state.booking_details.booking_details.customer_name}</div>
                  <div className="row col-md-6" style={styles.cart_contents}>Mobile No : {this.state.booking_details.booking_details.customer_mobile_no}</div>
                  
                </div>
                <div className="row col-md-12" style={{marginTop:'1%',display:'flex'}}>
                  <div className="row col-md-6" style={styles.cart_contents}>Court : {this.state.booking_details.court.name}</div>
                  <div className="row col-md-6" style={styles.cart_contents}>Start Time : @{this.state.booking_details.start_time}</div>
                </div>
                <div className="row col-md-12" style={styles.button_cell}>
                  <Link to = {`./crud/updateCourtBooking/${this.state.booking_details.id}`}>
                    <button className='button1' onClick={()=>{}} style={styles.button}>Update Equipment Rental</button>
                  </Link>
                  <button className='button1' onClick={()=>{this.cancelBookingPress(this.state.booking_details.id)}} style={styles.button}>Cancel Booking</button>
                  <button className='button1' onClick={()=>{this.updateSubscriptionPress(this.state.booking_details.id)}} style={styles.button}>Edit Booking</button>
                  <button className='button1' onClick={()=>{this.downloadInvoicePress(this.state.booking_details)}} style={styles.button}>Download Invoice</button>
                  <button className='button1' onClick={()=>{this.checkLog(this.state.booking_details)}} style={styles.button}>Check Log</button>
                </div>
            </div>
          }

          { this.state.failed_count > 0 && this.state.failed_slots && this.state.failed_slots.length > 0 && this.state.show_dialog ?
            <div className="col-md-12">
              <Dialog
                    actions={okaction}
                    modal={false}
                    open={this.state.show_dialog}
                    onRequestClose={this.handleFailedClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                  >
                <div >
                  <div style={styles.main_header} className="col-md-12">
                    <h4 style={{textAlign:'center'}}> Failed To Book </h4>
                  </div>
                  <div className="col-md-12" style={{flexDirection:'row',textAlign:'center',fontWeight:'600',padding:'1%',color:'#32B6A7'}}>
                    {this.state.failed_count +' / '+ this.state.selected_bookings.length +' failed'}
                  </div>
                  {this.state.failed_slots.map((list,index) =>
                    <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      <div className="col-md-4">
                        {list.court}
                      </div>
                      <div className="col-md-4">
                        {list.start_time}
                      </div>
                      <div className="col-md-4">
                        {list.date}
                      </div>
                    </div>
                      ) 
                  }
                 </div> 
               </Dialog>
            </div>
            :
            ''
          }

          { this.state.update_dialog &&
              <div className="col-md-12">
                <Dialog
                      actions={update_action}
                      modal={false}
                      onRequestClose = {this.handleUpdateClose}
                      open={this.state.update_dialog}
                      autoDetectWindowHeight={true}
                      autoScrollBodyContent={true}
                    >
                  <div>
                    <div style={styles.title} className="col-md-12 label_blue_1">
                      <h4 style={{textAlign:'center'}}> Update Booking </h4>
                    </div>
                    <div className="col-md-12" style={{color:'red',fontSize:'80%',paddingLeft:'10%'}}>Update only remaining amount. </div>

                    <div style={styles.items} className="col-md-12">
                      <div style={styles.item_header} className="col-md-6">
                        Actual Price 
                      </div>
                      <div className="col-md-6" >
                        <i className="fa fa-rupee"></i> {this.state.booking_details.price}
                      </div>
                    </div>

                    <div style={styles.items} className="col-md-12">
                      <div style={styles.item_header} className="col-md-6">
                        Remaining Amount 
                      </div>
                      <div className="col-md-6" >
                        <i className="fa fa-rupee"></i> {this.state.booking_details.booking_details.remaining_amount}
                      </div>
                    </div>


                    <div style={styles.items} className="col-md-12">
                      <div style={styles.item_header} className="col-md-6">
                        Amount 
                      </div>
                      <div className="col-md-6" >
                        <input type="number" style={styles.input} className="required" name="amount" value={this.state.amount}
                        onChange={(event)=>{this.setState({amount:event.target.value})}}/> 
                      </div>
                    </div>

                    <div style={styles.items} className="col-md-12">
                      <div style={styles.item_header} className="col-md-6">
                        Discount Amount 
                      </div>
                      <div className="col-md-6" >
                        <input type="number" style={styles.input} className="required" name="discount_amount" value={this.state.discount_amount}
                        onChange={(event)=>{this.setState({discount_amount:event.target.value})}}/> 
                      </div>
                    </div>

                    { this.createPaymentUI() }

                    <div style={{direction:'rtl'}}><i className='fa fa-plus fa-2x' onClick={this.addPaymentClick.bind(this)} style={{color:'#32B6A7',cursor:'pointer'}}/></div>

                    {/*<div style={styles.items} className="col-md-12">
                                          <div style={styles.item_header} className="col-md-6">
                                            Payment Mode 
                                          </div>
                                          <div className="col-md-6" style={styles.item_body}>
                                            <select name="payment_mode"  value={this.state.value}
                                            onChange={this.handleMode}>
                                            <option>--select--</option>
                                            {
                                               Object.keys(this.state.payment_modes).map((key, index) => (
                                               <option key={key} value={key}>{`${this.state.payment_modes[key]}`}</option>
                                               ))
                                             }
                                            </select>
                                          </div>
                                        </div>*/}

                    {/*<div className="col-md-12" style={{color:'red',fontSize:'80%',paddingLeft:'10%'}}>Only select customer in case to shift the booking to new customer </div>
                    
                    
                                        <div style={styles.items} className="col-md-12">
                                          <div style={styles.item_header} className="col-md-4">
                                            Customer
                                          </div>
                                          <div className="col-md-8 input-group" style={{width:'69%'}}>
                                            <input type="text" name="display_name" className="form-control"
                                              placeholder="Search for.. " value={this.state.cust_details.display_name}
                                              data-customerId={this.state.cust_details.id}
                                              onChange={this.handleChange} style={{ backgroundColor: this.state.value_set ? '#32B6A7': 'white'}}/>
                                            <span className="input-group-btn">
                                              <button className="btn btn-default glyphicon glyphicon-search"
                                              type="button" onClick={this.searchCustomer}></button>
                                            </span>
                                          </div>
                                          {this.state.search?
                                            <div className="col-md-12 btn-group">
                                            {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                                              style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                                              :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                                                <div className="alert alert-danger">Search customer not found</div>
                                              <div>
                                            <RaisedButton
                                              onClick={this.handleOpen}
                                              label="Add"
                                              style={{float:'right'}}
                                              secondary={true}
                                            />
                                            <Dialog
                                              actions={actions}
                                              modal={false}
                                              open={this.state.dialog_open_cust}
                                              onRequestClose={this.handleClose}
                                            >
                                              <div>
                                                  <div style={styles.main_header} className="col-md-12">
                                                      <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                                                    </div>
                                                        <div style={styles.items} className="col-md-12">
                                                          <div style={styles.item_header} className="col-md-6">
                                                            Name
                                                          </div>
                                                          <input type="text" style={styles.input} name="name" className="required"
                                                            value={this.state.value} onChange={this.handleChange}/>
                                                        </div>
                    
                                                        <div style={styles.items} className="col-md-12">
                                                          <div style={{fontSize: '120%',fontWeight: 600,paddingLeft: '11%',}} className="col-md-6">
                                                            Mobile No
                                                          </div>
                                                        <input type="number" style={styles.input} name="mobile_no" className="required"
                                                          value={this.state.cust_details.mobile_no} onChange={this.handleChange}/>
                                                      </div>
                                                    </div>
                                                  </Dialog>
                                            
                                              </div>
                    
                                            </div>
                                          }</div>:''
                                        }
                                        </div>*/}
                        
                  </div> 
                </Dialog>
              </div>
          }

          { this.state.cb_logs && this.state.cb_logs.length > 0 && this.state.show_log_dialog ?
                      <div className="col-md-12">
                        <Dialog
                              actions={okayaction}
                              modal={false}
                              open={this.state.show_log_dialog}
                              onRequestClose={()=>{this.setState({show_log_dialog:false})}}
                              autoDetectWindowHeight={true}
                              autoScrollBodyContent={true}
                            >
                          <div >
                            <div style={styles.main_header} className="col-md-12">
                              <h4 style={{textAlign:'center'}}> Log History </h4>
                            </div>
                            {this.state.cb_logs.map((list,index) =>
                              <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                                <div className="col-md-3">
                                  {list.customer.name}
                                </div>
                                <div className="col-md-3">
                                  {list.customer.mobile_number}
                                </div>
                                <div className="col-md-3">
                                  {list.state}
                                </div>
                                <div className="col-md-3">
                                  {list.extra_details}
                                </div>
                              </div>
                                ) 
                            }
                          </div> 
                        </Dialog>
                      </div>
                      :
                      ''
                    }

          { !this.state.checkout && this.state.selected_bookings && this.state.selected_bookings.length > 0 && this.state.booking_summary?
              <div className="col col-md-10" style={styles.cart}>
                <div className="col-md-12" style={styles.booking}>BOOKING SUMMARY </div>

                <div  style={styles.cart_header}>
                  { booking_headers.map(header=>
                    <div style={{fontSize:'100%',textAlign: 'center',width: (header == 'Date' || header == 'Court')? '20%' :header == 'Time' ? '35%' :header == 'Price'? '15%':'5%' ,marginRight:'1%'}}>{header}</div>
                  )}
                </div>
                
                  { this.state.selected_bookings.map((booking, index)=>(

                      <div key={index} style={styles.cart_rows}>
                        <div  style={{fontSize:'100%',textAlign: 'center',width:'5%',marginRight:'1%'}}><i className="fa fa-chevron-right fa-2x" style={{color:'#32B6A7'}}/></div>
                        <div  style={{fontSize:'100%',textAlign: 'center',width:'20%',marginRight:'1%'}}>{booking.court.name}</div>
                        <div  style={{fontSize:'100%',textAlign: 'center',width:'20%',marginRight:'1%'}}>{moment(booking.date).format('DD/MM/YYYY')}</div>
                        <div  style={{fontSize:'100%',textAlign: 'center',width:'35%',marginRight:'1%'}}>{moment(booking.start_time,"HH:mm:ss").format('hh:mm A') +' - ' + moment(booking.end_time,"HH:mm:ss").format('hh:mm A')}</div>
                        <div  style={{fontSize:'100%',textAlign: 'center',width:'15%',marginRight:'1%'}}>{booking.price}</div>
                        <div  style={{fontSize:'100%',textAlign: 'center',width:'5%',marginRight:'1%'}}><i className='fa fa-times fa-2x' onClick={()=>this.removeFromCart(booking)} style={{color:'red',cursor:'pointer'}}/></div>
                      </div>
                      )
                    )
                  }
                <div className='col-md-12' style={styles.total}>
                  <div style={{float:'right'}}> Total Payable :- Rs. {this.state.total_amount}/- </div>
                </div>
                <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                  <div style={{fontSize: '120%',fontWeight: 600,paddingLeft: '10%',width:'50%'}} className="col-md-6">
                    Customer No
                  </div>
                  <div className="col-md-6 input-group" style={{width:'50%'}}>
                    <input type="text" name="display_name" className="form-control"
                      placeholder="Search for.. " value={this.state.cust_details.display_name}  onChange={this.handleChange} style={{backgroundColor: this.state.value_set?'#32B6A7': 'white'}}/>
                    <span className="input-group-btn">
                      <button className="btn btn-default glyphicon glyphicon-search"
                      type="button" onClick={this.searchCustomer}></button>
                    </span>
                  </div>
                </div>
                {this.state.search?
                  <div className="col-md-12 btn-group" style={{width:'97%'}}>
                            {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                        style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                        :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                <div className="alert alert-danger">Search customer not found</div>
                <div>
                    <RaisedButton
                      onClick={this.handleOpen}
                      label="Add"
                      style={{float:'right'}}
                      secondary={true}
                    />
                    <Dialog
                      actions={actions}
                      modal={false}
                      open={this.state.dialog_open_cust}
                      onRequestClose={this.handleClose}
                    >
                      <div>
                          <div style={styles.main_header} className="col-md-12">
                              <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                            </div>
                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Name
                                  </div>
                                  <input type="text" style={styles.input} name="name" className="required"
                                    value={this.state.value} onChange={this.handleChange}/>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Mobile No
                                  </div>
                                <input type="number" style={styles.input} name="mobile_no" className="required"
                                  value={this.state.cust_details.mobile_no} onChange={this.handleChange}/>
                              </div>
                            </div>
                          </Dialog>
                        
                        </div>
                        </div>
                      }
                </div>:''

                }

                <div className='col-md-12' style={styles.button_cell}>
                  <button className='button1' style={styles.button} onClick={()=>this.handleCheckout()}> Checkout </button>
                </div>
              </div>
            :
            ''
          }

          {this.state.selected_bookings.length > 0 && this.state.checkout &&
            <div className="row col-md-10" style={styles.cart}>
              <div style={{fontSize:20,color:'black',marginBottom:10,textAlign:'center'}}>Book Court</div>

                {Object.keys(this.state.cart).length > 0 ?
                  this.state.cart.items ?
                      this.state.cart.items.map((item, index) => {
                          return(
                              <div style={styles.cart_item_container} className="col-md-12" key={index}>
                                  <div style={styles.cart_item_image} className="col-md-2">
                                      <img src={
                                          item.object.image ?
                                          (item.object.image.indexOf("assets.sporthood.in") > 0 && item.object.image.indexOf("api.sporthood.in") > 0) ?
                                          item.object.image :
                                          `https://api.sporthood.in/media/${item.object.image}`
                                          :
                                          null
                                      }/>
                                  </div>
                                  <div className="col-md-6">
                                      <div style={styles.cart_item_title} className="col-md-12">
                                          {item.object.name}
                                      </div>
                                      {/* <div style={styles.cart_item_remove} className="col-md-8">
                                          <i className="fa fa-trash"></i>
                                          &nbsp;
                                          Remove from cart
                                      </div> */}
                                      <button className="btn btn-sm" type="button" style={styles.cart_item_remove} onClick={() => this.removeCartItem(this.state.cust_details.customer_id, item.id)}>
                                          <i className="fa fa-trash"></i>
                                          &nbsp;
                                          Remove from cart
                                      </button>

                                  </div>

                                 { /*<div style={styles.cart_item_price} className="col-md-4 pull-right">
                                                                       <div style={styles.cart_item_amount} className="col-md-12">
                                                                           <i className="fa fa-rupee"></i> {item.invoice_items[0].amount}
                                                                       </div>
                                                                       <div style={styles.cart_item_tax} className="col-md-12">
                                                                           {item.invoice_items[1].description}: <i className="fa fa-rupee"></i> {item.invoice_items[1].amount}
                                                                       </div>
                                                                   </div>*/}
                              </div>
                          );
                      })
                    :
                    <div style={styles.cart_empty} className="col-md-12">
                        {/* --- Empty --- */}
                    </div>
                  :
                  ''
                }
                
                {/*<div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Total Amount 
                                  </div>
                                  <div className="col-md-6">
                                    {this.state.total_amount}
                                  </div>
                                </div>*/}

                  {/*<div style={styles.items} className="col-md-12">
                                      <div style={styles.item_header} className="col-md-6">
                                        Amount Collected 
                                      </div>
                                      <div className="col-md-3">
                                        <input type="number" style={styles.input} name="collected_amount" 
                                          value={this.state.collected_amount} onChange={(event)=>{this.setState({collected_amount:event.target.value})}}/> 
                                      </div>
                                    </div>*/}
                  {/* <div style={{padding: '1%',display:'flex',flexDirection:'row'}} className="col-md-12">
                                      <div style={{fontSize: '120%',fontWeight: 600,width:'50%',paddingLeft:'10%'}} className="col-md-6">
                                        Coupon Code
                                      </div>
                                      {
                                          Object.keys(this.state.cart).length > 0 ?
                                              this.state.cart.coupon ?
                                                  this.state.cart.coupon.code ?
                                                      <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                                                          <input type="text" style={styles.input} name="coupon" 
                                                          disabled={true}
                                                          value={this.state.cart.coupon.code} onChange={this.handleChange}/>
                                                          <button className="btn btn-sm pull-right col-md-3" type="button" style={{backgroundColor:'#302C35',
                                                          color:'#ffffff',alignSelf:'flex-end'}} onClick={() => this.removeCoupon(this.state.cart.coupon.code)}>
                                                              Remove Coupon
                                                          </button>
                                                      </div>
                                                      :
                                                      <div style={{display:'flex',flexDirection:'column',width:'50%'}}>
                                                          <input type="text" style={styles.input} name="coupon" 
                                                          // disabled={this.state.sub_details.coupon}
                                                          value={this.state.cust_details.coupon} onChange={this.handleChange}/>
                                                          <button className="btn btn-sm pull-right col-md-3" type="button" style={{backgroundColor:'#302C35',
                                                              color:'#ffffff',alignSelf:'flex-end'}} onClick={() => this.applyCoupon(this.state.cust_details.coupon)}>
                                                              Apply Coupon
                                                          </button>
                                                      </div>
                                                  :
                                                  <div>
                                                      <input type="text" style={styles.input} name="coupon" className='col-md-3'
                                                      // disabled={this.state.sub_details.coupon}
                                                      value={this.state.cust_details.coupon} onChange={this.handleChange}/>
                                                      <button className="btn btn-sm pull-right col-md-3" type="button" style={{backgroundColor:'#302C35',
                                                          color:'#ffffff'}} onClick={() => this.applyCoupon(this.state.cust_details.coupon)}>
                                                          Apply Coupon
                                                      </button>
                                                  </div>
                                              :
                                              <div>
                                                  <input type="text" style={styles.input} name="coupon" className='col-md-3'
                                                  // disabled={this.state.sub_details.coupon}
                                                  value={this.state.cust_details.coupon} onChange={this.handleChange}/>
                                                  <button className="btn btn-sm pull-right col-md-3" type="button" style={{backgroundColor:'#302C35',
                                                      color:'#ffffff'}} onClick={() => this.applyCoupon(this.state.cust_details.coupon)}>
                                                      Apply Coupon
                                                  </button>
                                              </div>
                                      }
                                    </div> */}
                  <div style={styles.items} className="col-md-12">
                     <div style={styles.items} className="col-md-12" >
                       <div style={styles.item_header} className="col-md-4">
                         Order total
                       </div>
                       <div style={{...styles.item_header, textAlign: "right"}} className="col-md-4 pull-right">
                           <i className="fa fa-rupee"></i> &nbsp;
                           {this.state.cart.amount}
                       </div>
                     </div>
                  {/* <input type="number" style={styles.input} name="amount" className="required"
                    value={this.state.value} onChange={this.handleChange}/> */}
                  </div>
                   <div style={{padding: '1%',display:'flex',flexDirection:'row',width:'100%'}} className="col-md-12">
                  <div style={{width:'50%',fontSize: '120%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                    Source
                  </div>
                  <select name="source" className="col-md-6" style={styles.item_body} style={{width:'50%'}} value={this.state.value}
                    onChange={this.handleChange}>
                      <option>WALK IN</option>
                      <option>Other</option>
                      <option>PLAYO</option>
                  </select>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Discount Amount 
                  </div>
                  <div className="col-md-6" >
                    <input type="number" style={styles.input} className="required" name="discount_amount" value={this.state.discount_amount}
                    onChange={(event)=>{this.setState({discount_amount:event.target.value})}}/> 
                  </div>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Advance Amount 
                  </div>
                  <div className="col-md-6" >
                    <input type="number" style={styles.input} name="advance_amount" 
                      value={this.state.advance_amount} onChange={(event)=>{this.setState({advance_amount:event.target.value})}}/> 
                  </div>
                </div>


                { this.createPaymentUI() }

                <div style={{direction:'rtl'}}><i className='fa fa-plus fa-2x' onClick={this.addPaymentClick.bind(this)} style={{color:'#32B6A7',cursor:'pointer'}}/></div>

                <div className="row col-md-12" style={styles.button_cell}>
                  <button className='btn btn-default' onClick={()=>{this.onAddBookingPress()}} style={styles.button}>Book</button>
                </div>
              </div>
          }

          <div>
          {Object.keys(this.state.slot_list).length > 0 &&
            <table className="table_plain" style={{marginTop:'1%',overflowX:'auto'}}>
              <tr>
                <th style={{padding:'1% 0%',backgroundColor:'#3CB3E2',color:'white',position:'sticky',left:0}}>Time Slot </th>
                {this.state.court_list.map((court, index)=>{
                    return(
                      <th style={{padding:'1% 0%',backgroundColor:'#3CB3E2',color:'white'}}>{court}</th>
                    )
                })}
              </tr>

            
                {Object.keys(this.state.slot_list).sort().map((v, i,element)=> {
                return(

                <tr style={{verticalAlign:'inherit'}}> 
                    <td style={{padding:'1% 0%',position:'sticky',left:0,backgroundColor:'#dcdcdc',display:'inline',whiteSpace:'nowrap'}}>{this.state.slot_list[v][0]['start_time']}-{this.state.slot_list[v][0]['end_time']}</td>

                    {this.state.slot_list[v].sort((a,b)=>{return (a.court.name > b.court.name) ? 1 : ((b.court.name > a.court.name) ? -1 : 0)}).map((obj,index)=>{
                      return(
                      <td >
                        <button className='button1' onClick={()=>{this.handleSlots(obj)}} style={(obj.status === true)? {color:'white',backgroundColor:`${obj.booking.color}`,padding:'1% 10%',marginRight:'2px'}:(this.state.selected_court_ids.includes(obj.id) ? {color:'white',backgroundColor:'#41E0F0',padding:'1% 10%'}:{color:'white',backgroundColor:'grey',padding:'1% 10%'})}>
                          {obj.is_equipment_updated === true ? <span>{<i className="fa fa-dribbble"></i>}</span> : <div />}
                          {obj.status === true ?
                              obj.is_booked_as_other_part === true ?
                              <a data-for='global_two' data-tip={"Booked as part of other sport | "} style={{color:'black'}}>Booked</a>
                              :
                              obj.is_booking_in_progress === true ?
                              <a data-for='global_two' data-tip={"Booking is in progress | "} style={{color:'black'}}>In Progress</a>
                              :
                                obj.is_blocked === true ?
                                      <a data-for='global_one' data-tip={`${obj.booking.name}|${obj.booking.mobile_no}|${obj.booking.source}|${obj.booking.amount}|${obj.is_equipment_updated}|${obj.reason}|${obj.details.batch_size}|${obj.details.voted_in}|${obj.details.percentage}`}  style={{color:'white'}}>{obj.reason?obj.reason:'Other'}</a>
                                      :
                                obj.booking.paylater === true ?
                                      <a data-for='global_three' data-tip={`${obj.booking.name}|${obj.booking.mobile_no}|${obj.booking.source}|${obj.booking.total_amount}|${obj.booking.advance_amount}|${obj.booking.discount_amount}|${obj.booking.remaining_amount}`}  style={{color:'white'}}>Pay Later</a>
                                      :
                                      <a data-for='global' data-tip={`${obj.booking.name}|${obj.booking.mobile_no}|${obj.booking.source}|${obj.booking.amount}|${obj.booking.booking_amount}|${obj.booking.discount_amount}|${obj.booking.price}|${obj.is_equipment_updated}`}  style={{color:'white'}}>{obj.booking.name === '' ? (obj.booking.mobile_no) :(is_mobile()? ( obj.booking.name.substr(0,5)=== 'playo'?obj.booking.name.substr(0,5):obj.booking.name.split(' ')[0]):(obj.booking.name))}</a>

                            : "Book"
                          }
                        </button>  
                      </td>
                      )
                      
                    })}
                 </tr>
                 )
              })}
            </table>
          }

          <div className="col-md-12" style={{justifyContent:'center',marginLeft:'6%',marginTop:10}}>
          <div className="col-md-6" style={{display:'flex',flexDirection:'row'}}>
            <div className="row col-md-4" style={{display:'flex',flexDirection:'row',width:'33%'}}>
              <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'rgba(255,204,0,0.8)'}}></div>
              <div className="row col-md-10" style={{ marginLeft:8}}>Internal Blocking</div>
            </div>
            <div className="row col-md-4" style={{display:'flex',flexDirection:'row',marginLeft:'9%',width:'33%'}}>
              <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#1B30EC'}}></div>
              <div className="row col-md-10" style={{ marginLeft:8}}>Bulk Booking</div>
            </div>
            <div className="row col-md-4" style={{display:'flex',flexDirection:'row',marginLeft:'10%',width:'33%'}}>
              <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#ffb266'}}></div>
              <div className="row col-md-10" style={{ marginLeft:8}}>Utilization &lt; 50%</div>
            </div>
          </div>
          <div className="col-md-6" style={{display:'flex',flexDirection:'row',marginTop:2}}>
            <div className="row col-md-4" style={{display:'flex',flexDirection:'row',width:'33%'}}>
              <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#388585'}}></div>
              <div className="row col-md-10" style={{ marginLeft:8}}>App</div>
            </div>
            <div className="row col-md-4" style={{display:'flex',flexDirection:'row',marginLeft:'9%',width:'33%'}} >
              <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#ff0033'}}></div>
              <div className="row col-md-10" style={{ marginLeft:8}}>Payment Incomplete</div>
            </div>
            <div className="row col-md-4" style={{display:'flex',flexDirection:'row',marginLeft:'10%',width:'33%'}}>
              <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#1f960d'}}></div>
              <div className="row col-md-10" style={{ marginLeft:8}}>Playo</div>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{justifyContent:'center',marginLeft:'6%'}}>
          <div className="col-md-6" style={{display:'flex',flexDirection:'row',marginTop:2}}>
              <div className="row col-md-4" style={{display:'flex',flexDirection:'row',width:'33%'}}>
                <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#00FF00'}}></div>
                <div className="row col-md-10" style={{ marginLeft:8}}>Playspots</div>
              </div>
              <div className="row col-md-4" style={{display:'flex',flexDirection:'row',marginLeft:'9%',width:'33%'}}>
                <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#ffff66'}}></div>
                <div className="row col-md-10" style={{ marginLeft:8}}>Utilization &lt; 70%</div>
              </div>
              <div className="row col-md-4" style={{display:'flex',flexDirection:'row',marginLeft:'10%',width:'33%'}}>
                <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#b2ff66'}}></div>
                <div className="row col-md-10" style={{ marginLeft:8}}>Utilization &gt; 70%</div>
              </div>
            </div>
            <div className="col-md-6" style={{display:'flex',flexDirection:'row',marginTop:2}}>
              <div className="row col-md-4" style={{display:'flex',flexDirection:'row',width:'33%'}}>
                <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#e3850f'}}></div>
                <div className="row col-md-10" style={{ marginLeft:8}}>Other Source</div>
              </div>
              <div className="row col-md-4" style={{display:'flex',flexDirection:'row',marginLeft:'9%',width:'33%'}}>
                <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#FF6666'}}></div>
                <div className="row col-md-10" style={{ marginLeft:8}}>Slots with amount 0</div>
              </div>
              <div className="row col-md-4" style={{display:'flex',flexDirection:'row',marginLeft:'10%',width:'33%'}}>
                <div className="row col-md-2" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#888c0f'}}></div>
                <div className="row col-md-10" style={{ marginLeft:8}}>Website</div>
              </div>
            </div>
          </div>

          

               <ReactTooltip id='global_one'
                            getContent={(dataTip) =>{
                              if (!dataTip) {
                                return "";
                              }
                              const [name,number,source,amount,equipment,reason,batch_size,voted_in,percentage] = dataTip.split("|")
                              return(
                                <div className="col-md-12">
                                  <div className="row" style={{fontSize:12}}>Name: {name}</div>
                                  <div className="row" style={{fontSize:12}}>Mobile: {number}</div>
                                  <div className="row" style={{fontSize:12}}>Source: {source}</div>
                                  <div className="row" style={{fontSize:12}}>Equipment: {(equipment === 'true') ? <span>Yes</span> : <span>No</span>}</div>
                                  <div className="row" style={{fontSize:12}}>Reason: {reason}</div>
                                  <div className="row" style={{fontSize:12}}>Batch Size: {batch_size}</div>
                                  <div className="row" style={{fontSize:12}}>Voted In: {voted_in}</div>
                                  <div className="row" style={{fontSize:12}}>Percentage Utilized: {percentage+" %"}</div>
                                </div> )}}
                                 effect='solid'
                                 place={'top'}
                                 border={true}
                                 type={'light'}/>

                 <ReactTooltip id='global'
                            getContent={(dataTip) =>{
                              if (!dataTip) {
                                return "";
                              }
                              const [name,number,source,amount,booking_amount,discount_amount,price,equipment] = dataTip.split("|")
                              return(
                                <div className="col-md-12">
                                  <div className="row" style={{fontSize:12}}>Name: {name}</div>
                                  <div className="row" style={{fontSize:12}}>Mobile: {number}</div>
                                  <div className="row" style={{fontSize:12}}>Source: {source}</div>
                                  {/*<div className="row" style={{fontSize:12}}>Total Amount: {amount}</div>*/}
                                  <div className="row" style={{fontSize:12}}>Collected Amount: {booking_amount}</div>
                                  <div className="row" style={{fontSize:12}}>Discount Amount: {discount_amount}</div>
                                  <div className="row" style={{fontSize:12}}>Slot Price: {price}</div>
                                  <div className="row" style={{fontSize:12}}>Equipment: {(equipment === 'true') ? <span>Yes</span> : <span>No</span>}</div>
                                </div> )}}
                                 effect='solid'
                                 place={'top'}
                                 border={true}
                                 type={'light'}/>

              <ReactTooltip id='global_two'
                                          getContent={(dataTip) =>{
                                            if (!dataTip) {
                                              return "";
                                            }
                                            const [name] = dataTip.split("|")
                                            return(
                                              <div className="col-md-12">
                                                <div className="row" style={{fontSize:12}}>{name}</div>
                                              </div> )}}
                                              effect='solid'
                                              place={'top'}
                                              border={true}
                                      type={'light'}/>

              <ReactTooltip id='global_three'
                            getContent={(dataTip) =>{
                              if (!dataTip) {
                                return "";
                              }
                              const [name,number,source,amount,advance_amount,discount_amount,remaining_amount] = dataTip.split("|")
                              return(
                                <div className="col-md-12">
                                  <div className="row" style={{fontSize:12}}>Name: {name}</div>
                                  <div className="row" style={{fontSize:12}}>Mobile: {number}</div>
                                  <div className="row" style={{fontSize:12}}>Source: {source}</div>
                                  <div className="row" style={{fontSize:12}}>Total Amount: {amount}</div>
                                  <div className="row" style={{fontSize:12}}>Advance Amount: {advance_amount}</div>
                                  <div className="row" style={{fontSize:12}}>Discount Amount: {discount_amount}</div>
                                  <div className="row" style={{fontSize:12}}>Remaining Amount: {remaining_amount}</div>
                                </div> )}}
                                effect='solid'
                                place={'top'}
                                border={true}
                        type={'light'}/>
            </div>
            </div>
          }
          </div>
        </div>
        </div>
        
      </div>  
      );
    }
  }
  
  export default PartnerCourtBooking;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/partnerCourtBooking/PartnerCourtBooking.js